import { render, staticRenderFns } from "./breastDetails.vue?vue&type=template&id=108bc866&"
import script from "./breastDetails.vue?vue&type=script&lang=js&"
export * from "./breastDetails.vue?vue&type=script&lang=js&"
import style0 from "./breastDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports